export default "__VITE_ASSET__85cbdaaf__"